import { useEffect, useState } from "react";

const useCountdown = (target: string) => {
  const count_down_date = new Date(target).getTime();
  const [count_down, setCountDown] = useState(
    count_down_date - new Date().getTime()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(count_down_date - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [count_down_date]);

  return getReturnValues(count_down);
};

const getReturnValues = (count_down: number) => {
  const days = Math.floor(count_down / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (count_down % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((count_down % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((count_down % (1000 * 60)) / 1000);

  return [days, hours, minutes, seconds];
};

export { useCountdown };
